import iconCheckboxEmpty from './check-box-empty-min.png'
import iconCheckboxChecked from './check-box-min.png'
import homeBackground from './home-background.png'
import homeLogo from './home-logo.png'
import iconEyeOff from './icon/icon-eye-off.png'
import iconEyeOn from './icon/icon-eye-on.png'
import iconHelp from './icon/icon-help.svg'
import iconPinMap from './icon/icon-pin-map.png'
import pjInfo from './pjInfo.png'

const images = {
  homeLogo,
  homeBackground,
  iconEyeOff,
  iconEyeOn,
  iconHelp,
  iconPinMap,
  iconCheckboxEmpty,
  iconCheckboxChecked,
  pjInfo,
}

export default images
